import { Attribute } from "api"

const logos = {
  car: "/images/LocatorCar.png",
  yellow: "/images/locatoryellow.png",
  advice: "/images/locatoradvice.png",
  blue: "/images/locatorblue.png",
  freshmarket: "/images/locatorfrashmarket.png",
  hyper: "/images/locatorhyper.png",
  warehouse: "/images/locatorwarehouse.png",
  wareother: "/images/locatorwareother.png",
  wash: "/images/locatorwash.png",
  habib: "/images/locatorHabib.png",
  yehuda: "/images/super-yuda.png",
}

export const getLogo = (metadata: Attribute[]) => {

  if (metadata.some((el) => el.category === "שירותי רכב")) {
    return logos.car
  }
  if (metadata.some((el) => el.category === "yellow")) {
    return logos.car
  } else if (metadata.some((el) => el.name.includes("פרשמרקט"))) {
    return logos.freshmarket
  } else if (metadata.some((el) => el.name.includes("טיפ טוב"))) {
    return logos.advice
  } else if (metadata.some((el) => el.name === "היפר דודו")) {
    return logos.hyper
  } else if (metadata.some((el) => el.name === "מחסני להב")) {
    return logos.warehouse
  } else if (metadata.some((el) => el.name === "מחסני מזון")) {
    return logos.wareother
  } else if (metadata.some((el) => el.name === "סופר דוש")) {
    return logos.wash
  } else if (metadata.some((el) => el.category === "סופרים")) {
    return logos.hyper
  } else {
    return ""
  }
}

export const getLogoByName = (stationName: string, metadata: Attribute[]) => {

  if (stationName.includes("פרשמרקט")) {
    return logos.freshmarket;
  } else if (stationName.includes("טיפ טוב")) {
    return logos.advice;
  } else if (stationName.includes("היפר דודו")) {
    return logos.hyper;
  } else if (stationName.includes("מחסני להב")) {
    return logos.warehouse;
  } else if (stationName.includes("מחסני מזון")) {
    return logos.wareother;
  } else if (stationName.includes("סופר דוש")) {
    return logos.wash;
  } else if (stationName.includes("חביב")) {
    return logos.habib;
  } else if (stationName.includes("סופר יודה")) {
    return logos.yehuda;
  }

  if (metadata.some((el) => el.category === "yellow")) {
    return logos.car
  } else if (metadata.some((el) => el.category === "סופרים")) {
    return logos.hyper
  } else if (metadata.some((el) => el.category === "שירותי רכב")) {
    return logos.car
  }

  return logos.car
};
